import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useTranslation } from 'react-i18next';

function AddVideoLink({
    isOpen,
    onClose,
    onConfirm,
    appointmentId,
    item,
}) {
    const { t } = useTranslation();

    const methods = useForm();
    const [loader, setLoader] = useState(false);
    const { control, formState: { errors }, handleSubmit } = methods;

    useEffect(() => {
        if (isOpen) {
            methods.reset({ 
                video_link: item?.appointment_details?.video_link || '' 
            })
        }
    }, [isOpen, item])



    return (
        <>
            <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
                <form action="" onSubmit={handleSubmit((data) => {
                    setLoader(true);
                    onConfirm(data, "video_link", ()=> setLoader(false))
                })}>
                    <ModalHeader className='header_modal align-items-center'>
                        <h5 className="modal-title_u">{t("addVideoLink.title")}</h5>
                    </ModalHeader>
                    <ModalBody className='modal_form_body'>
                        <div className='step_cards step_1'>
                            <h2>{t("translation.appointmentId")}: {appointmentId}</h2>
                            <div className="row-primary">
                                <h2>{t("addVideoLink.label")}</h2>
                                <div className='w-100'>
                                    <div className="row-primary w-100">
                                        <Controller
                                            name="video_link"
                                            control={control}
                                            rules={{
                                                required: t("addVideoLink.required")
                                            }}
                                            render={({ field }) =>
                                                <>
                                                    <textarea
                                                        className="type_inp input-in"
                                                        {...field}
                                                        placeholder={t("addVideoLink.placeholder")}
                                                        required
                                                    >
                                                    </textarea>

                                                    {errors?.video_link?.message && (
                                                        <ErrorMessage
                                                            text={errors?.video_link?.message}
                                                        />
                                                    )}
                                                </>
                                            }

                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <SubmitButton buttonType="submit" className={'primary'} loader={loader} btnText={t("translation.submit")} />
                        <button className="table_delete" type='button' onClick={onClose}>{t("billing.cancel")}</button>
                    </ModalFooter>
                </form>
            </Modal>
        </>
    );
}

export default AddVideoLink;